import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import SignupContainer from './SignupContainer'
import { createUser } from './actions'
const queryString = require('query-string');

const mapStateToProps = (state, ownProps) => {
  const query = queryString.parse(ownProps.location.search)
  const signupType = query.signup_type

  const redirectToQuery = query.signup_type || query.redirect_to
  const { from } = ownProps.location.state ||  { from: { pathname: redirectToQuery || '/premium' } }
  return {
    h3: (signupType == 'accountants') ? "Accountant Sign Up" : "Welcome to Everlance!",
    isFetching: state.models.user.isFetching,
    signupErrorMessage: state.models.user.signupErrorMessage,
    locationSearch: ownProps.location.search,
    from,
    query
  }
}

const mapDispatchToProps  = (dispatch, ownProps) => {
  return {
    handleOnSubmit: (event, data)=> {
      event.preventDefault()
      return dispatch(createUser(data))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignupContainer)



// WEBPACK FOOTER //
// ./src/user/SignupPage.js